import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {ScrollbarWithEndingBlindsModule} from '../scrollbar-with-ending-blinds';
import {L10nModule} from '../translate';
import {AutocompleteListComponent} from './autocomplete-list.component';
import {AutocompleteDirective} from './autocomplete.directive';
import {AutocompleteService} from './autocomplete.service';

@NgModule({
    imports: [
        CommonModule,
        L10nModule,
        ScrollbarWithEndingBlindsModule
    ],
    declarations: [
        AutocompleteDirective,
        AutocompleteListComponent
    ],
    exports: [
        AutocompleteDirective
    ],
    providers: [
        AutocompleteService
    ]
})
export class AutocompleteModule {}
